import { defineStore } from 'pinia'
import { getManyDictItems } from '@/api/dict'

const allDictCodes = [
  // Step1
  'assessment_reason',
  'nation',
  'sex',
  'belief',
  'marital',
  'education',
  'live',
  'medical',
  'sources',
  'iac_customer_cdqk',
  'iac_customer_jsjb',
  'iac_assessment_suicide',
  'iac_assessment_choking',
  'iac_assessment_be_lost',
  'iac_assessment_fall',
  'relationship',
  'report_assessment_motion',
  'report_assessment_spirit',
  'report_assessment_sense',

  // Step2_1
  'iac_daily_life_js',
  'iac_daily_life_xz',
  'iac_daily_life_xs',
  'iac_daily_life_cy',
  'iac_daily_life_dbkz',
  'iac_daily_life_xbkz',
  'iac_daily_life_rc',
  'iac_daily_life_cyzy',
  'iac_daily_life_pdxz',
  'iac_daily_life_sxlt',
  'iac_assess_rcshhddj',

  // Step2_2
  'iac_mental_state_rzgn',
  'iac_mental_state_gjxw',
  'iac_mental_state_yyzz',
  'iac_assess_jsztdj',

  // Step2_3
  'iac_perception_yssp',
  'iac_perception_sl',
  'iac_perception_tl',
  'iac_perception_gtjl',
  'iac_assess_gzjygtdj',

  // Step2_4
  'iac_social_shnl',
  'iac_social_gznl',
  'iac_social_sjkjdx',
  'iac_social_rwdx',
  'iac_social_shjwnl',
  'iac_assess_shcydj',

  // 访客登记
  'iac_car_type',

  // 客户档案
  'iac_care_risk',
  'iac_dietary_type',
  // 护士证书
  'iac_nurse_certificate_type',
  // 设备告警类型
  'iac_alarm_type',
  // 外出申请状态
  'iac_check_oor_status',
  // 外出陪同人员关系类型
  'entourage',
]

export const useDictStore = defineStore('dict', {
  state: () => ({
    dictMap: {},
    loading: false,
    loaded: false,
  }),
  actions: {
    async fetchAllDicts(forceRefresh = false) {
      // 如果已经加载且不是强制刷新，则直接返回
      if (this.loaded && !forceRefresh) {
        return
      }

      this.loading = true
      try {
        const response = await getManyDictItems(allDictCodes)
        if (response) {
          this.dictMap = response
          this.loaded = true
        }
      } catch (error) {
        console.error('获取字典数据失败', error)
      } finally {
        this.loading = false
      }
    },

    // 重置字典数据，用于登录时强制刷新
    resetDict() {
      this.dictMap = {}
      this.loaded = false
    },
  },
  getters: {
    getDict: (state) => (code) => {
      return state.dictMap[code] || []
    },
    getDictMap: (state) => (codes) => {
      const result = {}
      if (!codes || codes.length === 0) {
        return state.dictMap
      }
      for (const code of codes) {
        if (state.dictMap[code]) {
          result[code] = state.dictMap[code]
        }
      }
      return result
    },
  },
  persist: {
    key: 'dict-store',
    paths: ['dictMap', 'loaded'],
    storage: {
      getItem: uni.getStorageSync,
      setItem: uni.setStorageSync,
    },
  },
})
